import { CircularProgress } from '@mui/material'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { CustomInput } from 'src/consumer/components/helperComponents'
import { PracticeDoneButton } from '../../StreakPage/styledComponent'
import { AddPracticeListItem, AddPracticeSearchInputContainer } from './styledComponents'
import { attachMeditationsToTimer } from './utils'

export default function AttachPracticeToExisting({
  myTimers,
  selectedPractices,
  setSelectedPractices,
  backToPreviousPage,
  clientSessionId,
}) {
  const [tempPractices, setTempPractices] = useState()
  const [saving, setSaving] = useState(false)
  const [search, setSearch] = useState('')

  function toggleSelectPractice(practice, idx) {
    setSelectedPractices((prev) => {
      var newSelectedPractices = [...prev]
      if (newSelectedPractices.find((prac) => prac?.id === practice?.id)) {
        newSelectedPractices = newSelectedPractices.filter((prac) => prac?.id !== practice?.id)
      } else {
        newSelectedPractices.push(practice)
      }
      return newSelectedPractices
    })
  }

  async function handleSubmit() {
    setSaving(true)
    console.log({ selectedPractices })
    const resp = await attachMeditationsToTimer(selectedPractices, clientSessionId)
    if (resp.status === 200) {
      backToPreviousPage()
    } else {
      toast.error('Something went wrong! Please try again.')
    }
    setSaving(false)
  }

  useEffect(() => {
    setTempPractices(
      !!search
        ? myTimers.filter((practice) => practice.title.toLowerCase().includes(search))
        : myTimers,
    )
  }, [search])

  useEffect(() => {
    setTempPractices(myTimers)
    console.log({ myTimers })
  }, [myTimers])

  return (
    <>
      <CustomInput
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        inputAndMessageContainer={AddPracticeSearchInputContainer}
        placeholder="Search"
        conponentContainerStyles={{ position: 'sticky', top: '0px', zIndex: 3 }}
      />
      {tempPractices?.map((practice, idx) => (
        <AddPracticeListItem
          key={idx}
          onClick={() => toggleSelectPractice(practice, idx)}
          selected={selectedPractices?.find((prac) => prac?.id === practice?.id)}
        >
          <span>{practice?.title}</span>
          <span>{selectedPractices?.find((prac) => prac?.id === practice?.id) ? '✅' : ''}</span>
        </AddPracticeListItem>
      ))}
      <PracticeDoneButton
        disabled={selectedPractices?.length === 0 || saving}
        onClick={handleSubmit}
        sx={{ position: 'sticky', bottom: '20px', margin: '20px auto 0px' }}
      >
        <div
          style={{
            position: 'relative',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {saving && (
            <CircularProgress
              sx={{
                color: '#fff',
                position: 'absolute',
                width: '25px !important',
                height: '25px !important',
              }}
            />
          )}
          Done
        </div>
      </PracticeDoneButton>
    </>
  )
}
